import * as React from 'react';
import { Team } from '../../../models';
import { FilterStore } from '../../../stores';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import './PVASelect.css';

interface PVATeamSelectProps {
    options: Team[];
    selected: number | undefined;
    onChange: Function;
    FilterStore?: FilterStore;
    defaultOptions?: any[];
    disabled?: boolean;
}

interface PVATeamSelectState {
    isOpen: boolean;
}

@inject('FilterStore') @observer
export class PVATeamSelect extends React.Component<PVATeamSelectProps, PVATeamSelectState> {
    constructor(props: PVATeamSelectProps) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    private selectedTeam() {
        if (this.props.selected === undefined) {
            return null;
        }
        if (this.props.defaultOptions) {
            var opt = this.props.defaultOptions.find((t: any) => {
                return t.id === this.props.selected;
            });
            if (opt) {
                return opt;
            }
        }
        return this.props.options.find((t: Team) => {
            return t.id === this.props.selected;
        });
    }

    private teamChange(team: any) {
        if (this.props.onChange) {
            this.props.onChange({
                target: {
                    value: team.id
                }
            });
        }
        this.setState({ isOpen: !this.state.isOpen });
    }

    private sortTeams(a: Team, b: Team): number {
        if (a.name > b.name) {
            return 1;
        } else if (a.name < b.name) {
            return -1;
        }

        return 0;
    }

    render() {
        var  teamSelected = this.selectedTeam();

        let className = 'pva-select-box-selected';
        if (this.props.disabled === true) {
            className = `${className} disable-control`;
        }
        if (this.state.isOpen) {
            className = `${className} open`;
        }

        return (
            <div className="pva-select-box">
                <div className={className} onClick={(e) => this.setState({ isOpen: !this.state.isOpen })}>
                    {teamSelected &&
                        <div className="user-row">
                            <span>{teamSelected.name || teamSelected.value} </span>
                        </div>
                    }
                    {!teamSelected &&
                        <div className="user-row">
                            <span>- Select Team -</span>
                        </div>
                    }
                    <div className="pva-select-box-toggle">
                        {!this.state.isOpen && <span className="glyphicon glyphicon-triangle-bottom" />}
                        {this.state.isOpen && <span className="glyphicon glyphicon-triangle-top" />}
                    </div>
                </div>
                {this.state.isOpen &&
                    <div className="pva-select-box-options">
                        {this.props.defaultOptions && this.props.defaultOptions.map((option: any) => {
                            return <div key={`select-opt-${option.id}`} className="user-row" onClick={(e) => this.teamChange(option)}>
                                <div className="user-name"><span>{option.value}</span></div>
                            </div>;
                        })}
                        {this.props.options.sort(this.sortTeams).map((team: Team, index: number) => {
                            return <div key={`select-opt-${team.id}`} className="user-row" onClick={(e) => this.teamChange(team)}>
                                <div className="user-name"><span>{team.name}</span></div>
                            </div>;
                        })}
                    </div>}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVATeamSelect.tsx